<template>


    <UiNarrowContent v-if="article.image">
      <UiArticleImage :article="article" class="mb-6" />
    </UiNarrowContent>

    <UiExtraNarrowContent>
        <h3 class="mt-6">
          {{ article.title }}
        </h3>
        
        <div  v-html="cleanHtml(article.contenthtml)"/>                                         
    </UiExtraNarrowContent>
 
</template>

<script setup>
import { useBlogStore } from '@/stores/blogStore';
import { computed } from 'vue';

// Props
defineProps({
    article: {
        type: Object,
        required: true
    }
});

// Function to clean HTML content, keeping only allowed tags
const cleanHtml = (html) => {
  const allowedTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'strong', 'em', 'a', 'br', 'iframe'];
  const regex = /<\/?([a-z][a-z0-9]*)[^>]*>/gi;

  // Keep only allowed tags
  let cleaned = html.replace(regex, (match, tag) => {
    return allowedTags.includes(tag.toLowerCase()) ? match : '';
  });

  // Fix iframe wrapping: close surrounding <p>, insert block div, reopen if needed
  cleaned = cleaned.replace(/<p>(\s*)?(<iframe[^>]*src=["']([^"']+)["'][^>]*><\/iframe>)(\s*)?<\/p>/gi, (match, before, iframeTag, src) => {
    try {
      const url = new URL(src);
      const allowedDomains = ['youtube.com', 'player.vimeo.com', 'youtu.be'];
      if (allowedDomains.some(domain => url.hostname.includes(domain))) {
        return `<div class="video-wrapper">${iframeTag}</div>`;
      }
    } catch (e) {}
    return ''; // remove invalid
  });

  return cleaned;
};
</script>

<style scoped>
/* Global styles for <ol> inside v-html */
.content-html ol {
  list-style-type: decimal;
  margin-left: 1.5rem;
  padding-left: 1.5rem;
}

.content-html li {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
}

.content-text {
  font-size: 1rem;
  line-height: 1.5;
}

/* Margins on extra small screens */
@media (max-width: 480px) { /* Extra small screens */
  .mb-6 {
    margin-bottom: 0 !important;
  }

  .mt-6 {
    margin-top: 16 !important;
  }
}

/* Styles for videos from blog content */

::v-deep(.content-html p iframe) {
  aspect-ratio: 16 / 9;
  width: 100%;
  height: auto;
  display: block;
  margin: 1.5rem 0;
  border: none;
  border-radius: 0.5rem;
}

@media (max-width: 768px) {
  ::v-deep(.content-html p iframe) {
    margin: 1rem 0;
    border-radius: 0.25rem;
  }
}

@media (max-width: 480px) {
  ::v-deep(.content-html p iframe) {
    margin: 0.75rem 0;
  }
}
</style>
